import type { ApiError } from '@approvalmax/types';

import { authErrorCodes } from './constants';

export const isAuthError = (e: ApiError) => {
    return e.status === 401 || authErrorCodes.includes(e.code || '');
};
